import React, {Component} from "react";
import {Card, Icon, Steps, Divider, Progress, Row, Col, Typography} from "antd";
import ParterCompanyRegistration from "./ParterCompanyRegistration";
import PartnerContactDetailsForm from "./PartnerContactDetailsForm";
import PartnerAdditionalDetails from "./PartnerAdditionalDetails";
import './style.less';

const Step = Steps.Step;
const { Text, Title } = Typography;
const token = localStorage.getItem('token')?localStorage.getItem('token'): null;

class PartnerRegistration extends Component {
  constructor(props) {
    super(props);
    let type = this.props.role?this.props.role:"partner";
    this.state = {
      step: type === "partner"?0:0,
      type:type
    };
  }
  componentDidMount() {
    const user_role = this.props.role
    if (user_role === 'agent' || user_role === 'internal_agent')
    {
      if (localStorage.getItem('uuid'))
      {
        this.setState({step:0});
      }
      else{
      this.setState({step:0});
      }
    }
  }

  handleNext = () => {
    this.setState({step: this.state.step+1});
  }
  handleBack = () => {
    this.setState({step: this.state.step-1});
  }
  getStatus = (status,step) => {
    if(status===step){
      return "process"
    }
    if(status<step){
      return "wait"
    }
    if(status>step){
      return "finish"
    }
  }

  onChange = current => {
    console.log('onChange:', current);
    if(this.props.role === "partner"){
      current === 0?this.setState({ step: 1 }):this.setState({ step: current })
    }else{
      this.setState({ step: current });
    }
  };

  renderLeftPanelContent() {
    const { step } = this.state;

    switch(step) {
      case 0:
        return (
          <div className="gx-benefits-screen-content">
            <Title level={2} style={{ color: "white", textAlign: "center" }}>Step 1: Contact Details</Title>
            <Text style={{ fontSize: 20, color: "white", textAlign: "center" }}>Build trust by adding your personal and professional contact info.</Text>
          </div>
        );
      case 1:
        return (
          <div className="gx-benefits-screen-content">
            <Title level={2} style={{ color: "white", textAlign: "center" }}>Step 2: Company Info</Title>
            <Text style={{ fontSize: 20, color: "white", textAlign: "center" }}>Let us know about your company, size, expertise and location.</Text>
          </div>
        );
      case 2:
        return (
          <div className="gx-benefits-screen-content">
            <Title level={2} style={{ color: "white", textAlign: "center" }}>Step 3: Additional Details</Title>
            <Text style={{ fontSize: 20, color: "white", textAlign: "center" }}>Final touches! Add certifications, experience, and portfolios.</Text>
          </div>
        );
      default:
        return null;
    }
  }

  render(){
    const { step } = this.state;
    const totalSteps = 3;
    const maxIndex   = totalSteps - 1;
    const percent = ((step + 1) / (maxIndex + 1)) * 100;
    return (
      <div className="gx-app-login-wrap gx-app-partner-registration">
        <div className="gx-app-login-container">
          <Row type="flex" className="gx-app-login-main-content">
            <Col xl={12} lg={12} md={24} sm={24} xs={24} className="emptySpacing left-info" style={{ height: "100vh", backgroundColor: "#630086" }}>
              <div className="gx-benefits-screen">
                <img src={require('assets/images/LogoUniserved.png')} alt='Neature' />
                {this.renderLeftPanelContent()}
              </div>
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24} className="emptySpacing right-form">
              <Card className="gx-sign-up-card" bordered={false}>
                <Title level={2}>Partner Registration</Title>
                <Text style={{fontSize:'18px'}}>Registration to manage your projects and showcase your skills. Matrix is the one stop interface between you and Uniserved.</Text>
                {this.state.step <= 5 && (
                  <Steps  current={step} onChange={this.onChange} style={{ display: 'none'}}>
                    <Step status={this.getStatus(this.state.step,0)} title="Contact Details" icon={<Icon type="user"/>}/>
                    <Step status={this.getStatus(this.state.step,1)} title="Company Details" icon={<Icon type="shop"/>}/>
                    <Step status={this.getStatus(this.state.step,2)} title="Additional Details" icon={<Icon type="copy" />}/>
                  </Steps>
                )}
                <Progress
                  percent={percent}
                  status="active"
                  showInfo={false}
                  strokeWidth={6}
                  strokeColor="#956ee7"
                  style={{ marginTop: 15 }}
                />
                <Divider/>
                {this.state.step ===0 && <PartnerContactDetailsForm handleNext={this.handleNext.bind(this)} handleBack={this.handleNext.bind(this)}/>}
                {this.state.step ===1 && <ParterCompanyRegistration handleNext={this.handleNext.bind(this)} handleBack={this.handleBack.bind(this)}/>}
                {this.state.step ===2 && <PartnerAdditionalDetails handleNext={this.handleNext.bind(this)} handleBack={this.handleBack.bind(this)}/>}
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default PartnerRegistration;
